export default __webpack_public_path__ + "static/media/PFBDentalPlan_ScheduleOfBenefits.4f430e03.pdf";